import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { Patient } from '../models/patient';
import { PatientService } from '../services/patient.service';

import { RestService } from '../services/rest.service';
import { BaseTable } from '../shared/base-table';
import { DatePipe } from '@angular/common';

@Component({
  selector: 'qmed-next-examination-list',
  templateUrl: '../shared/base-table.html',
  styleUrls: ['../shared/base-table.css'],
  encapsulation: ViewEncapsulation.None
})
export class NextExaminationListComponent extends BaseTable implements OnInit {
  public columns: Array<any> = [
    {
      title: 'Nume si prenume',
      name: 'fullName',
      sort: '',
      filtering: {filterString: '', placeholder: 'Cauta dupa nume/prenume'}
    },

    { title: 'Incadrare/Post', name: 'job', sort: false },
    { title: 'CNP', name: 'cnp', sort: false, filtering: {filterString: '', placeholder: 'Cauta dupa CNP'} },
    {
      title: 'Data urmatoarei examinari',
      name: 'dateOfNextExamination',
      sort: 'asc',
      type: 'date'
    }
  ];
  public config: any = {
    paging: true,
    sorting: { columns: this.columns },
    filtering: { filterString: '' },
    className: ['table-striped', 'table-bordered']
  };
  loading;
  boolean;
  public constructor(
    private restService: RestService,
    private patientService: PatientService
  ) {
    super();
    this.loading = true;
  }

  public ngOnInit(): void {
    this.tableTitle = 'Urmatoarele examinari';

    this.patientService.getAll().subscribe(res => {
      // This is needed to convert the apritude file into a link/button etc
      this.data = res.map(this.convertFullName);
      this.length = this.data.length;

      this.onChangeTable(this.config);
      this.loading = false;
    }, err => (this.loading = false));
  }

  convertFullName(patient: Patient) {
    const fullname = `${patient.lastName} ${patient.firstName}`;
    const dateString = patient.dateOfNextExamination;

    let formatedDateString = '';
    if (dateString != null || dateString !== undefined) {
      const datePipe = new DatePipe('en');
      formatedDateString = datePipe.transform(dateString, 'dd-MM-yyyy');
    }
    return new Patient(
      patient.firstName,
      patient.lastName,
      patient.cnp,
      patient.dateOfLastExamination,
      formatedDateString,
      patient.job,
      patient.aptitudeFileUrl,
      fullname
    );
  }
}



// WEBPACK FOOTER //
// /home/usr/clienti.qmedical/src/app/next-examination-list/next-examination-list.component.ts